module.exports = __webpack_public_path__ + "media/assets/community/resource-1-ac0a0321fe94946dd2c21092a55eb9eb171f9192117c0ef5746649ef49b5233d.png";